const resources = {
    new: 'nouveautés',
    newChatHeadingPdp: 'Essayez notre clavardage beauté IA',
    newChatHeadingPlp: 'Essayez notre clavardage beauté IA',
    aiChatInputPlaceholderPdp: 'Posez n’importe quelle question sur cet essentiel',
    aiChatInputPlaceholderPlp: 'Vous avez besoin d’aide pour trouver un essentiel?',
    aiChatInputPlaceholderPlpLgUi: 'Vous avez besoin d’aide pour trouver quelque chose?',
    aiChat: 'AI Chat'
};

export default function getResource(label) {
    return resources[label];
}
